import { theme } from '../../../themes';

// Method to set sentence capitalization of one sentence.
// This method is designed to handle text such as button titles, modal titles, and others which are
// a one-sentence text.
export const applyRequiredCapitalizations = (sentence) => {
  if (!theme.fonts.isExperienceTextCapitalized || !sentence || sentence.indexOf('.') !== -1) {
    return sentence;
  }

  if (sentence.length === 1) {
    return sentence.toUpperCase();
  }

  return sentence[0].toUpperCase() + sentence.substring(1).toLowerCase();
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/util/TextUtils.js